<template>
    <q-card class="report-select-card" flat bordered>
        <!-- Header -->
        <q-card-section>
            <q-badge
                v-if="showNewBadge"
                class="widget-badge"
                color="positive"
                :label="$t('New')"
            />
            <div class="text-h6 q-pb-sm">
                <q-icon v-if="icon" :name="icon" class="text-secondary" />
                {{ title }}
            </div>
            <div class="text-secondary" style="min-height: 85px">
                <p class="ellipsis-3-lines">{{ description }}</p>
            </div>
        </q-card-section>
    </q-card>
</template>

<script>
export default {
    name: 'ReportSelectCard',
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false,
            default: null
        },
        description: {
            type: String,
            required: true
        },
        showNewBadge: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.report-select-card {
    cursor: pointer;
}

.widget-badge {
    position: absolute;
    top: -10px;
    left: -5px;
    z-index: 10;
    padding: 6px 10px;
}
</style>
